var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.modalId,"title":"Политика конфиденциальности","hide-footer":"","centered":"","size":"xl"}},[_c('p',[_vm._v(_vm._s(_vm.PRIVACY_TEXT))])])}
var staticRenderFns = []

export { render, staticRenderFns }